// extracted by mini-css-extract-plugin
export default {"select":"Inventory_select__pmDE6"};